import DocumentTableSelector from './DocumentTableSelector';

export default DocumentTableSelector;
